import {
    Button,
    CloseIcon,
    Dialog,
    EditIcon,
    MenuButton,
    MoreIcon,
    TrashCanIcon,
} from "@fluentui/react-northstar";
import { useState } from "react";

import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import DialogModifyTask from "../dialogsContents/ModifyTask";
import {
    useSetTasksLocally,
    useTasksLocally,
} from "../../hooks/useStoreTasksLocally";
import { string } from "prop-types";

const MoreItem = ({ task }) => {
    const { t } = useTranslation("translation");

    const [open, setOpen] = useState(false);
    const [openDialogModify, setOpenDialogModify] = useState(false);

    const CtxTasksLocally = useTasksLocally();
    const CtxSetTasksLocally = useSetTasksLocally();

    const methods = useForm();

    // delete task from store
    const onDelete = (id_to_remove) => {
        const new_list = CtxTasksLocally.filter(
            (task) => task.id !== id_to_remove
        );
        return CtxSetTasksLocally(new_list);
    };

    const onSubmit = (data) => {
        //* verify if the task is document_required and the user doesnt upload a required document.
        if (data?.document_required && data?.saved_files.length === 0) {
            methods.setError("document_action", {
                type: string,
                message:
                    "dans ce cas, le document est requis, veuillez ajouter un document.",
            });
            return;
        }

        const new_list = CtxTasksLocally.map((task) => {
            if (task.id === data.id) {
                return { ...task, ...data };
            }
            return task;
        });
        CtxSetTasksLocally(new_list);
        setOpenDialogModify(false);
        return;
    };

    return (
        <>
            <MenuButton
                open={open}
                onOpenChange={(e, { open }) => {
                    if (openDialogModify) {
                        return;
                    }
                    setOpen(open);
                }}
                trigger={
                    <Button
                        text
                        icon={<MoreIcon />}
                        title={"plus"}
                        onClick={() => null}
                    />
                }
                menu={[
                    <FormProvider {...methods} key="forms">
                        <form onSubmit={methods.handleSubmit(onSubmit)}>
                            <Dialog
                                open={openDialogModify}
                                cancelButton={t("common.cancel")}
                                confirmButton={t("Modifier une tâche")}
                                content={<DialogModifyTask task={task} />}
                                header={t(
                                    "pages.add_employee.step_tasks.dialog.modify_title"
                                )}
                                headerAction={{
                                    icon: <CloseIcon />,
                                    title: t("common.close"),
                                    onClick: () => {
                                        return setOpenDialogModify(false);
                                    },
                                }}
                                onCancel={() => {
                                    return setOpenDialogModify(false);
                                }}
                                onConfirm={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    methods.handleSubmit(onSubmit)();
                                    return;
                                }}
                                trigger={
                                    <Button
                                        icon={<EditIcon />}
                                        content={t("Modifier la tâche")}
                                        text
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            setOpenDialogModify(true);
                                        }}
                                    />
                                }
                                styles={{
                                    width: "700px",
                                }}
                            />
                        </form>
                    </FormProvider>,
                    <Button
                        key="form_btn"
                        styles={{ color: "red" }}
                        icon={<TrashCanIcon color="" />}
                        content={"Supprimer la tâche"}
                        text
                        onClick={() => {
                            onDelete(task?.id);
                            return null;
                        }}
                    />,
                ]}
            />
        </>
    );
};

export default MoreItem;
